<div id="footer">
  <div class="sections-container">
    <!-- Agriculture Marketplace -->
    <div class="section1 col-md-4">
      <div class="header-container d-flex flex-row">
        <img class="serp-logo" src="assets/logos/serp-logo.png" alt="serp-logo">
        <div class="header-text-container mt-1">
          <h1 class="serp-ap mt-0">SERP AP</h1>
          <p class="agriculture-marketplace">Agriculture Marketplace</p>
        </div>
      </div>
  
      <p class="description">A government initiative by the Society for Elimination of Rural Poverty, Andhra Pradesh, empowering farmers and agricultural enterprises through digital marketplaces.</p>
  
      <div class="icons-container">
        <a href="#"><i class="fa fa-facebook fa-lg"></i></a>
        <a href="#"><i class="fa fa-twitter fa-lg"></i></a>
        <a href="#"><i class="fa fa-linkedin fa-lg"></i></a>
        <a href="#"><i class="fab fa fa-youtube-play fa-lg"></i></a>
      </div>
    </div>
    <!-- /Agriculture Marketplace -->
  
    <!-- Marketplaces -->
    <div class="section2 mb-3 col-md-4">
      <div class="text-start">
        <h1 class="header mb-2">Marketplaces</h1>
    
        <a href="https://serpap-inputs.kalgudi.com" target="_blank">Input Marketplace</a>
        <a href="https://serpap-outputs.kalgudi.com" target="_blank">Output Marketplace</a>
        <a href="#">Credit Marketplace</a>
        <a href="#">Insurance Marketplace</a>
      </div>
    </div>
    <!-- /Marketplaces -->
    
    <hr class="horizontal-line mt-0">

    <!-- Contact information -->
    <div class="section3 col-md-4">
      <h1 class="contact-information mb-2">Contact Information</h1>
  
      <div class="location mb-3 d-flex justify-content-start">
        <mat-icon>location_on</mat-icon>
        <div>
          <p class="title mb-n2">Society for Elimination of Rural Poverty</p>
          <p>Vijayawada, Andhra Pradesh</p>
        </div>
      </div>
  
      <div class="phone mb-3 d-flex justify-content-start">
        <mat-icon>call</mat-icon>
        <div>
          <p class="title mb-n2">+91 1800 XXX XXXX</p>
          <p>Mon-Fri, 9 AM - 6 PM</p>
        </div>
      </div>
  
      <div class="email d-flex justify-content-start">
        <mat-icon>mail</mat-icon>
        <div>
          <p class="title mb-n2">support@serpap.gov.in</p>
          <p>Email Support</p>
        </div>
      </div>
    </div>
    <!-- /Contact Information -->
  </div>
  
  <hr class="horizontal-line mt-4">

  <!-- Privacy policy & Terms of Service -->
  <div class="terms-and-policy-container">
    <div class="terms-and-policy d-flex flex-row justify-content-space-between">
      <p>Terms of Service</p>
      <p class="privacy-policy">Privacy Policy</p>
    </div>
    <p>Powered by <img src="assets/logos/kalgudi-logo.svg" alt="kalgudi-logo" class="ml-1 mr-1"> Kalgudi</p>
    <p>© 2026 Society for Elimination of Rural Poverty. All Rights Reserved</p>
  </div>
  <!-- /Privacy policy & Terms of Service -->
</div>